<template>
  <div class="filter__menu m-4 vs-con-loading__container" id="filterMenu">
    <!-- seller profile -->
    <vs-card v-if="$route.params.id && $route.name === 'marketlist-view-sellerProducts' && seller">
      <div slot="header">
        <h3>Profile</h3>
      </div>
      <div class="profile__details p-5">
        <img class="w-32" src="@/assets/images/icons/verifyIcon.svg" v-if="verifiedSellersRole.includes(seller.role.id)" />
        <h1>{{ seller.business_name ? seller.business_name : seller.username }}</h1>
        <p>( {{ seller.omma_license_number }} )</p>
        <h4>{{ seller.role.role_name }}</h4>
      </div>
      <div slot="footer" class="flex justify-between pb-5">
        <div>Total Products</div>
        <div class="product_count rounded-sm">{{ total }}</div>
      </div>
    </vs-card>

    <!-- Filter Header -->
    <vs-card>
      <div slot="header" class="flex items-center justify-between">
        <h3>Filters By</h3>
        <vs-button v-if="filters.isFilterApplied" color="success" type="filled" @click="clearSearchFilters">Clear Filter</vs-button>
      </div>
    </vs-card>

    <!-- filters -->
    <vs-collapse class="p-0">
      <!-- verified seller filter -->
      <vs-collapse-item class="my-5 rounded-lg shadow-md filter__item" not-arrow>
        <div slot="header">By Verified Seller</div>
        <hr class="mb-4" />
        <ul>
          <li v-for="(item, index) in verifiedSellerOprions" :key="index" class="flex m-2">
            <vs-checkbox v-model="filters.verifiedSeller" :id="item.id" :vs-value="item.value" />
            {{ item.label }}
          </li>
        </ul>
      </vs-collapse-item>

      <!-- category filter -->
      <vs-collapse-item class="my-5 rounded-lg shadow-md filter__item" not-arrow :open="true">
        <div slot="header">By Category</div>
        <hr class="mb-4" />
        <ul>
          <li v-for="(category, index) in productCategories" :key="index" class="flex m-2">
            <vs-checkbox v-model="filters.categoryId" :vs-value="category.id" />
            {{ category.category_name }}
          </li>
        </ul>
      </vs-collapse-item>

      <!-- city filter -->
      <vs-collapse-item class="my-5 rounded-lg shadow-md filter__item" not-arrow>
        <div slot="header">By City</div>
        <hr class="mb-4" />
        <select-2 :ssr="false" class="w-full" :value="filters.cityId" @input="(item) => (filters.cityId = item && item.value)" placeholder="Please choose the City" :options="cityOptions" />
      </vs-collapse-item>

      <!-- weight filter -->
      <vs-collapse-item class="my-5 rounded-lg shadow-md filter__item" not-arrow>
        <div slot="header">By Weight</div>
        <hr class="mb-4" />
        <select-2 autocomplete class="w-full" :value="filters.weightType" @input="(item) => (filters.weightType = item && item.value)" placeholder="Please Select Weight Type" :options="weightTypes" />
      </vs-collapse-item>

      <!-- more filters -->
      <vs-collapse-item class="my-5 rounded-lg shadow-md filter__item" not-arrow>
        <div slot="header">More Filters</div>
        <hr class="mb-4" />

        <!-- CBD -->
        <label>CBD (%)</label>
        <vx-input-group class="mb-3">
          <vs-input type="number" v-model="filters.cbd" />

          <template slot="append">
            <div class="append-text bg-primary">
              <span>%</span>
            </div>
          </template>
        </vx-input-group>
        <hr class="my-4" />

        <!-- THC -->
        <label>THC (%)</label>
        <vx-input-group class="mb-3">
          <vs-input type="number" v-model="filters.thc" />

          <template slot="append">
            <div class="append-text bg-primary">
              <span>%</span>
            </div>
          </template>
        </vx-input-group>
        <hr class="my-4" />

        <!-- THC -->
        <label>Terpenoid Potency(%)</label>
        <vx-input-group class="mb-3">
          <vs-input type="number" v-model="filters.terpenoidPotency" />

          <template slot="append">
            <div class="append-text bg-primary">
              <span>%</span>
            </div>
          </template>
        </vx-input-group>
        <hr class="my-4" />

        <!-- room type -->
        <label for="">Room Type</label>
        <select-2 autocomplete class="w-full" :value="filters.roomType" @input="(item) => (filters.roomType = item && item.value)" placeholder="Please Select Room Type" :options="roomTypes" />
        <hr class="my-4" />

        <!-- plant stage -->
        <label for="">Plant Stage</label>
        <select-2 autocomplete class="w-full" :value="filters.plantStage" @input="(item) => (filters.plantStage = item && item.value)" placeholder="Please Select Plant Stage" :options="plantStages" />
        <hr class="my-4" />

        <!-- Grow method -->
        <label for="">Grow Method</label>
        <select-2 autocomplete class="w-full" :value="filters.growMethod" @input="(item) => (filters.growMethod = item && item.value)" placeholder="Please Select Grow Method" :options="growMethods" />
      </vs-collapse-item>
    </vs-collapse>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { weightTypes } from '@/utils/weightType'
import { roomTypes, plantStages, growMethods } from '@/utils/batch-options.js'
import { ADMIN, GROWER, PROCESSOR, RETAILER, DEMORETAILER } from '@/utils/roles.js'
import Select2 from '@/components/custom/form-elements/Select2.vue'

export default {
  name: 'FilterMenu',

  components: {
    Select2
  },

  props: {
    filters: {
      verifiedSeller: Array,
      categoryId: Array,
      weightType: String,
      cityId: Number,
      roomType: Array,
      plantStage: Array,
      growMethod: Array,
      cbd: Number,
      thc: Number,
      terpenoidPotency: Number
    }
  },
  data() {
    return {
      verifiedSellersRole: [ADMIN, GROWER, PROCESSOR, RETAILER],
      verifiedSellerOprions: [
        {
          id: 1,
          label: 'Verified Seller',
          value: true
        },
        {
          id: 2,
          label: 'Non-verified Seller',
          value: false
        }
      ],
      weightTypes,
      cityOptions: [],
      roomTypes,
      plantStages,
      growMethods,
      is_global: 'global',
      DEMORETAILER
    }
  },

  computed: {
    ...mapState('marketplace', ['seller', 'total']),
    ...mapState('product', { productCategories: 'product-categories', loading: 'category-loading' }),
    ...mapState('auth', ['user'])
  },

  async mounted() {
    try {
      // set the verified seller filter
      const tempVerifiesSeller = localStorage.getItem('marketplace_filters') ? JSON.parse(localStorage.getItem('marketplace_filters')).verifiedSeller : null
      if (tempVerifiesSeller && tempVerifiesSeller !== null) {
        this.filters.verifiedSeller = tempVerifiesSeller
      }
      // eslint-disable-next-line no-empty
    } catch (e) {}

    // get all product categories
    await this.getProductcategories()

    // get all city options
    await this.getAllCityOptions()
  },
  methods: {
    ...mapActions('product', { fetch_all_product_categories: 'getProductCategories' }),
    ...mapActions({ fetchCitiOptions: 'getCityOptions' }),

    // get all product categories
    async getProductcategories() {
      const { is_global } = this
      try {
        const payload = {
          search: '',
          limit: 0,
          page: 1,
          order: ['category_name', 'ASC'],
          is_global: this.user.roleId === DEMORETAILER ? null : is_global,
          is_status: true
        }

        await this.fetch_all_product_categories(payload)
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },

    // get all city options
    async getAllCityOptions() {
      try {
        const { data } = await this.fetchCitiOptions({ search: '' })
        this.cityOptions = data
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },

    // clear search filters
    async clearSearchFilters() {
      this.filters.isFilterApplied = false
      this.filters.verifiedSeller = []
      this.filters.search = ''
      this.filters.categoryId = []
      this.filters.weightType = null
      this.filters.cityId = null
      this.filters.cbd = null
      this.filters.thc = null
      this.filters.terpenoidPotency = null
      this.filters.roomType = []
      this.filters.plantStage = []
      this.filters.growMethod = []
    }
  },

  watch: {
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '#filterMenu',
          scale: 0.45,
          color: 'primary'
        })
      } else {
        this.$vs.loading.close('#filterMenu > .con-vs-loading')
      }
    }
  }
}
</script>

<style lang="scss">
.filter__menu {
  .open-item .vs-collapse-item--content {
    max-height: unset !important;

    .con-content--item {
      padding-top: 0;
    }
  }

  .vs-card--content {
    padding: 0;

    .profile__details {
      background: #28a745;

      img {
        margin-left: -30px;
      }

      h1,
      h4,
      p {
        color: #fff !important;
      }
    }
  }
  .product_count {
    background: blue;
    color: #fff;
    padding: 0 5px;
  }
}
.filter__item {
  background: #fff;
}
</style>
